export default __webpack_public_path__ + "static/media/bgtop1.7ac7d167.png";